import { Component, Input, OnInit } from '@angular/core';
import { faEnvelope, faGlobe, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Club } from 'app/shared/models/Club/clubs';
import { DetailsUser } from 'app/shared/models/Users/detailsUsers';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';

@Component({
  selector: 'app-my-club',
  templateUrl: './my-club.component.html',
  styleUrls: ['./my-club.component.scss']
})
export class MyClubComponent implements OnInit {

  @Input() userDetails: DetailsUser;

  faGlobe = faGlobe;
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  clubInfos: Club;

  constructor(
    private dataService: DataService,
    private ffvService: FfvapiService
  ) { }

  ngOnInit(): void {
    this.getMyClubInfos();
  }

  isMobile(): boolean {
    return this.dataService.isMobile();
  }

  private getMyClubInfos() {
    this.ffvService.getClubByUser(this.userDetails.cluB_CODE).subscribe(res => {
      this.clubInfos = res;
    });
  }

  back(): void {
    this.dataService.showMyClub.next(false);
  }


}
